export default "__VITE_ASSET__g9Lgj9Hb__"